var _a, _b;
/**
 * Consolidating all routes on this file
 */
import { PORTAL_ROUTE_PREFIX } from './values';
var SUBPAGE_NAMES;
(function (SUBPAGE_NAMES) {
    SUBPAGE_NAMES["CREATE_TEAM"] = "CREATE_TEAM";
    SUBPAGE_NAMES["CONTACT_SALES"] = "CONTACT_SALES";
    SUBPAGE_NAMES["ONBOARDING"] = "ONBOARDING";
    SUBPAGE_NAMES["HOME"] = "HOME";
    SUBPAGE_NAMES["PLACE_ORDER"] = "PLACE_ORDER";
    SUBPAGE_NAMES["EXPENSED_MEALS"] = "EXPENSED_MEALS";
    SUBPAGE_NAMES["DASSPASS"] = "DASSPASS";
    SUBPAGE_NAMES["EMPLOYEES"] = "EMPLOYEES";
    SUBPAGE_NAMES["GROUPS"] = "GROUPS";
    SUBPAGE_NAMES["GROUP_ORDERS"] = "GROUP_ORDERS";
    SUBPAGE_NAMES["PAYMENT_METHODS"] = "PAYMENT_METHODS";
    SUBPAGE_NAMES["BILLING_HISTORY"] = "BILLING_HISTORY";
    SUBPAGE_NAMES["CALENDAR"] = "CALENDAR";
    SUBPAGE_NAMES["OPT_IN"] = "OPT_IN";
    SUBPAGE_NAMES["VOUCHERS"] = "VOUCHERS";
    SUBPAGE_NAMES["VOUCHERS_CREATE"] = "VOUCHERS_CREATE";
    SUBPAGE_NAMES["VOUCHERS_DETAIL"] = "VOUCHERS_DETAIL";
    SUBPAGE_NAMES["VOUCHERS_EDIT"] = "VOUCHERS_EDIT";
    SUBPAGE_NAMES["PREVIEW_VOUCHER"] = "PREVIEW_VOUCHER";
    SUBPAGE_NAMES["ACCEPT_VOUCHER"] = "ACCEPT_VOUCHER";
    SUBPAGE_NAMES["GENERIC_JOIN_PAGE_V2"] = "GENERIC_JOIN_PAGE_V2";
    SUBPAGE_NAMES["JOIN_BY_INVITE"] = "JOIN_BY_INVITE";
})(SUBPAGE_NAMES || (SUBPAGE_NAMES = {}));
// Main Nav Routes
export var INTERNAL_PAGE_PATH = (_a = {},
    // Home or Onboarding Routes
    _a[SUBPAGE_NAMES.ONBOARDING] = '/onboarding',
    _a[SUBPAGE_NAMES.HOME] = '/home',
    // Voucher Routes
    _a[SUBPAGE_NAMES.VOUCHERS] = '/vouchers',
    _a[SUBPAGE_NAMES.VOUCHERS_CREATE] = '/vouchers/create',
    _a[SUBPAGE_NAMES.VOUCHERS_EDIT] = '/vouchers/:voucherId/edit',
    _a[SUBPAGE_NAMES.VOUCHERS_DETAIL] = '/vouchers/:voucherId/detail',
    _a[SUBPAGE_NAMES.PLACE_ORDER] = '/place-order',
    _a[SUBPAGE_NAMES.EXPENSED_MEALS] = '/budgets',
    _a[SUBPAGE_NAMES.DASSPASS] = '/dashpass',
    _a[SUBPAGE_NAMES.EMPLOYEES] = '/members',
    _a[SUBPAGE_NAMES.GROUPS] = '/groups',
    _a[SUBPAGE_NAMES.GROUP_ORDERS] = '/group-orders',
    _a[SUBPAGE_NAMES.PAYMENT_METHODS] = '/billing',
    _a[SUBPAGE_NAMES.BILLING_HISTORY] = '/order-history',
    _a);
// non-admin routes
export var ROUTES = (_b = {},
    _b[SUBPAGE_NAMES.CREATE_TEAM] = PORTAL_ROUTE_PREFIX + "/sign-up-team",
    _b[SUBPAGE_NAMES.OPT_IN] = PORTAL_ROUTE_PREFIX + "/opt-in",
    _b[SUBPAGE_NAMES.CONTACT_SALES] = PORTAL_ROUTE_PREFIX + "/contact-sales",
    _b[SUBPAGE_NAMES.CALENDAR] = PORTAL_ROUTE_PREFIX + "/calendar",
    _b[SUBPAGE_NAMES.PREVIEW_VOUCHER] = PORTAL_ROUTE_PREFIX + "/voucher/view/:teamAccountId/budget/:budgetId",
    _b[SUBPAGE_NAMES.ACCEPT_VOUCHER] = PORTAL_ROUTE_PREFIX + "/voucher/accept/:teamAccountId/budget/:budgetId",
    _b[SUBPAGE_NAMES.GENERIC_JOIN_PAGE_V2] = PORTAL_ROUTE_PREFIX + "/join",
    _b[SUBPAGE_NAMES.JOIN_BY_INVITE] = PORTAL_ROUTE_PREFIX + "/join/:pendingMemberId?",
    _b);
